function numberToTnWords(number) {
  const numberWords = {
    0: "ноль",
    1: "бир",
    2: "икки",
    3: "уч",
    4: "тўрт",
    5: "беш",
    6: "олти",
    7: "етти",
    8: "саккиз",
    9: "тўққиз",
    10: "ўн",
    20: "йигирма",
    30: "ўттиз",
    40: "қирқ",
    50: "эллик",
    60: "олтмиш",
    70: "етмиш",
    80: "саксон",
    90: "тўқсон",
    100: "юз",
    200: "икки юз",
    300: "уч юз",
    400: "тўрт юз",
    500: "беш юз",
    600: "олти юз",
    700: "етти юз",
    800: "саккиз юз",
    900: "тўққиз юз",
  };

  function convertNumberToWords(num) {
    if (numberWords[num]) {
      return numberWords[num];
    }

    let words = "";
    if (num >= 100) {
      let hundreds = Math.floor(num / 100) * 100;
      words += numberWords[hundreds] + " ";
      num %= 100;
    }
    if (num >= 10) {
      let tens = Math.floor(num / 10) * 10;
      words += numberWords[tens] + " ";
      num %= 10;
    }
    if (num > 0) {
      words += numberWords[num] + " ";
    }

    return words.trim();
  }

  let [integerPart, fractionalPart] = number.toString().split(".");
  integerPart = parseInt(integerPart);
  fractionalPart = fractionalPart ? parseFloat("0." + fractionalPart) : 0;

  let result = "";

  // Convert integer part
  if (integerPart > 0) {
    result += convertNumberToWords(integerPart) + " тн";
  }

  // Convert fractional part (multiply by 1000 to get hundreds)
  if (fractionalPart > 0) {
    let fractionalAsHundreds = Math.round(fractionalPart * 1000); // e.g., 0.2 * 1000 = 200
    result += " " + convertNumberToWords(fractionalAsHundreds) + " кг";
  }

  return result.trim();
}
export default numberToTnWords;
